import { FactoryProvider } from '@angular/core';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { BrandingManagerService } from '@rx-applications/shared/branding/api';
import { TranslationLoaderFn, inlineLoaderFactory } from '@rx-applications/shared/utils';

export function createTranslationProvider(
  loaderFn: TranslationLoaderFn,
  TRANSLATION_SCOPE: string,
  baseTranslationPath: string = '.',
): FactoryProvider {
  return {
    provide: TRANSLOCO_SCOPE,
    useFactory: (brandingManager: BrandingManagerService) => {
      const brandFolder = brandingManager.getBrandAccess().getTranslationPath();
      return {
        scope: TRANSLATION_SCOPE,
        loader: inlineLoaderFactory(loaderFn, baseTranslationPath, brandFolder),
      };
    },
    deps: [BrandingManagerService],
  };
}